module.exports = __webpack_public_path__ + "static/media/yashtelkhade.c27f3705.jpg";